<template>
    <span>
        <svg width="100%" height="100%" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Comps" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Public-Profile---Edit" transform="translate(-688.000000, -2014.000000)" fill-rule="nonzero">
                    <g id="Button/Round/Edit" transform="translate(688.000000, 2014.000000)">
                        <g id="Group-13">
                            <circle id="Oval" fill="" cx="16" cy="16" r="16"></circle>
                            <g id="Group-12" transform="translate(16.485281, 16.899495) rotate(45.000000) translate(-16.485281, -16.899495) translate(13.985281, 6.399495)" fill="#FFFFFF">
                                <polygon id="Rectangle" points="0.227922061 4.32842712 4.22792206 4.32842712 4.22792206 18.2288796 2.27060738 20.3284271 0.227922061 18.2288796"></polygon>
                                <rect id="Rectangle" x="0.227922061" y="0.0147186258" width="4" height="2"></rect>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    </span>
</template>
<script>
export default {
    name: "IconEdit"
};
</script>
